<template>
  <div>
    <v-menu
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          text
          class="text-body-1"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small class="pr-2">fa-filter</v-icon>
          Filtro avançado
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Numero carteirinha</v-list-item-title>
            <v-text-field
              solo
              @input="handleNumeroCarteira"
              :value="numeroCarteira"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Numero Guia prestador</v-list-item-title>
            <v-text-field
              solo
              @input="handleNumeroPrestador"
              :value="numeroGuiaPrestador"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Quantidade de itens</v-list-item-title>
            <v-text-field
              solo
              @input="handleQuantidadeItens"
              :value="quantidadeItens"
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-tooltip right v-if="(numeroCarteira || quantidadeItens || numeroGuiaPrestador)">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          icon
          @click="handleClearFilter"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small class="pr-2">fa-minus</v-icon>
        </v-btn>
      </template>
      <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
        Remover filtro
      </span>
    </v-tooltip>
  </div>
</template>

<script>

export default {
  props: {
    numeroCarteira: String,
    quantidadeItens: String,
    numeroGuiaPrestador: String
  },
  methods: {
    handleNumeroCarteira (newValue) {
      return this.$emit('update:numeroCarteira', newValue)
    },
    handleQuantidadeItens (newValue) {
      console.log(newValue)
      return this.$emit('update:quantidadeItens', newValue)
    },
    handleNumeroPrestador (newValue) {
      return this.$emit('update:numeroGuiaPrestador', newValue)
    },
    handleClearFilter () {
      return this.$emit('clearFilter')
    }
  }
}
</script>
